import { render, staticRenderFns } from "./MyIssue.vue?vue&type=template&id=b5944138&scoped=true&"
import script from "./MyIssue.vue?vue&type=script&lang=js&"
export * from "./MyIssue.vue?vue&type=script&lang=js&"
import style0 from "./MyIssue.vue?vue&type=style&index=0&id=b5944138&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5944138",
  null
  
)

export default component.exports